module.exports = __webpack_public_path__ + "0501f796d09b6ef781ceed9071dfcd21.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TF.svg
// module id = jp+a
// module chunks = 0